import React from 'react'
import ReactDOM from 'react-dom'
// Templates
import Note from './templates/Note'

export default function DictationOverlapping() {
  const mainText = `
  動画内容とあわせて解説プリントをご確認ください。
  `
  const textList = [
    {
      text: '●「主な音声変化まとめ」プリント（Dictation ＆ Overlapping 動画用）',
      fileName: '主な音声変化ルール_まとめプリント_STRAIL'
    },
  ]

  return (
    <Note
      mainText={mainText}
      textList={textList}
    />
  )
}

if (document.getElementById('dictation_overlapping')) {
  ReactDOM.render(
    <DictationOverlapping />,
    document.getElementById('dictation_overlapping')
  )
}